"use strict";

exports.__esModule = true;
exports.numericInputMinMaxSanitizer = void 0;
var numericInputMinMaxSanitizer = exports.numericInputMinMaxSanitizer = function numericInputMinMaxSanitizer(value, min, max) {
  if (isNaN(value)) {
    return min;
  }
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
};